import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';

import { AppDataContext } from '../../context';
import { isCourseA5DayChallenge } from '../../utils';
import type { CourseData } from '../../types';

import './index.scss';

interface ModuleOutlineProps {
  courseInfo: CourseData;
  courseInfoLoaded: boolean;
}

const ModuleOutline: React.FC<ModuleOutlineProps> = ({ courseInfo, courseInfoLoaded }) => {
  const { courseID } = useParams();
  const { allowedCourses } = useContext(AppDataContext);
  const courseOutline = courseInfo?.course_outline?.[0]?.children?.[0]?.children;

  if (!courseInfoLoaded || !courseOutline?.length) {
    return null;
  }

  const getUnitTitle = (name: string) => {
    let customTitle = '';
    const match = name?.match(/^(\d+(?:\.\d+)?)\s*(.*)$/);

    if (match) {
      customTitle = isCourseA5DayChallenge(String(courseID), false, allowedCourses) ? match[1] + match[2] : match[2];
    }

    return match ? customTitle : name;
  };

  return (
    <div className="course-info-panel-2 course-info-panel-3">
      <div className="overlap-group nimg overlap-group-custom">
        {courseOutline.map((outlineData: { display_name: string }, index: number) => {
          const match = outlineData?.display_name?.match(/^(?!5-)(\d+(?:\.\d+)?)\s*(.*)$/);
          const unitNumber = match ? match[1] : `1.${index + 1}`;
          const unitTitle = getUnitTitle(outlineData?.display_name);

          return (
            <div key={outlineData.display_name} className="frame-21-custom">
              <div className="unit-item a-leader-in-all-of-us instrumentserif-normal-congress-blue-37-5px">
                <span className="unit-number">{unitNumber}</span>
                <div className="unit-content">
                  <span className="unit-dot" />
                  <span className="unit-title">{unitTitle}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ModuleOutline;
